<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar()"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Participante"
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col
            v-for="(item, index) in participante" 
            :key="index"
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != ''">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    cardLoading: true
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("detallesParticipante", this.$route.params.id_participante)
    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },

  computed: {
    participante() {
      const detalles = this.$store.getters.obtenerParticipante;
      const participante = [
        {
          label: 'Identificación',
          value: detalles.identificacion
        },

        {
          label: 'Nombres',
          value: detalles.nombres
        },

        {
          label: 'Apellidos',
          value: detalles.apellidos
        },

        {
          label: 'Correo Electrónico',
          value: detalles.correo
        },

        {
          label: 'Télefono',
          value: detalles.telefono_movil
        },

        {
          label: 'Fecha de Nacimiento',
          value: detalles.fecha_nacimiento
        },

        {
          label: 'Dirección',
          value: detalles.direccion
        },

        {
          label: 'Genero',
          value: detalles.genero
        },

        {
          label: 'Programa de Formación',
          value: detalles.programa_formacion
        },

        {
          label: 'Número de Ficha',
          value: detalles.numero_ficha
        },

        {
          label: 'Talla de Camiseta',
          value: detalles.talla_camiseta
        },

         {
          label: 'Regional',
          value: detalles.regional
        },

        {
          label: 'Centro de Formación',
          value: detalles.centro_formacion
        },
      ];

      return participante;
    },
  },

  methods: {
    regresar() {
      this.$router.back()
    }
  }
};
</script>